import { library } from '@fortawesome/fontawesome-svg-core';

import { faCircle } from '@fortawesome/free-regular-svg-icons';
import {
    faArrowLeft,
    faChevronLeft,
    faArrowRight,
    faChevronRight,
    faCheck,
    faQuestionCircle,
    faQuoteLeft,
    faStar,
    faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faArrowLeft,
    faChevronLeft,
    faArrowRight,
    faChevronRight,
    faCheck,
    faCircle,
    faQuestionCircle,
    faQuoteLeft,
    faStar,
    faTimesCircle
);